// Evaluation Headers / Edit
(() => {
  'use strict';

  /* ************************************************** */
  /* ***************** TURBOLINKS LOAD **************** */
  /* ************************************************** */
  document.addEventListener('turbolinks:load', async event => {
    if (document.getElementById("translate_gaps")) {
      const gaps = JSON.parse(document.getElementById('translate_gaps').getElementsByTagName('tbody')[0].getAttribute('data-gaps'));
      const capacities = JSON.parse(document.getElementById('translate_gaps').getElementsByTagName('tbody')[0].getAttribute('data-capacities'));
      const strategies = JSON.parse(document.getElementById('translate_gaps').getElementsByTagName('tbody')[0].getAttribute('data-strategies'));
      const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
      
      drawGaps(gaps, capacities, strategies, lang);
      changeFesp(gaps, capacities, strategies, lang);
      saveGaps(gaps, lang);
      downloadReport();
    }
  });

  /* ************************************************** */
  /* ***************** EVENT TRIGGERS ***************** */
  /* ************************************************** */
  const changeFesp = (gaps, capacities, strategies, lang) => {
    document.getElementById('fesp_gaps').addEventListener('change', event => {
      drawGaps(gaps, capacities, strategies, lang);
    });
  };

  const saveGaps = () => {
    document.getElementById('btn_save_gaps').addEventListener('click', e => {
      let survey_selected = document.getElementById('fesp_gaps').value, changes = [];
      
      [...document.getElementsByTagName('textarea')].forEach(gap => {
        changes.push({ key: gap.getAttribute('name'), value: gap.value.replaceAll('\n', '') })
      });
      
      fetch(`/gaps/save`, {
        method: "POST",
        headers: new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.getElementsByName('csrf-token')[0].attributes['content'].value
        }),
        body: JSON.stringify({ gaps: { survey: survey_selected, changes: changes }})
      })
      .then(response => { 
        return response.json(); 
      })
      .catch(error => {
        console.log(error);
      })
      .then(data => {
        console.log(data);
        swal("Proceso de carga terminado");
      });
    });
  };

  const downloadReport = () => {
    document.getElementById('download-report-xlsx-gaps').addEventListener('click', event => {
      event.preventDefault();
      let button = document.getElementById("download-report-xlsx-gaps"),
          href_report = new URL(window.location.origin + button.getAttribute('href'));

      href_report.searchParams.set('fesp', document.getElementById('fesp_gaps').value);
      button.setAttribute('href', href_report.toString().replace(window.location.origin, ''))

      window.location = button.getAttribute('href');
    });

    document.getElementById('download-report-xlsx-gaps-content').addEventListener('click', event => {
      event.preventDefault();
      let button = document.getElementById("download-report-xlsx-gaps-content"),
          href_report = new URL(window.location.origin + button.getAttribute('href'));

      href_report.searchParams.set('fesp', document.getElementById('fesp_gaps').value);
      button.setAttribute('href', href_report.toString().replace(window.location.origin, ''))

      window.location = button.getAttribute('href');
    });
  }

  /* ************************************************** */
  /* ******************** FUNCTIONS ******************* */
  /* ************************************************** */
  const drawGaps = (gaps, capacities, strategies, lang) => {
    let survey_selected = document.getElementById('fesp_gaps').value,
        current_gaps = gaps[lang]["evaluation_headers"]["gaps"][survey_selected.toLowerCase()],
        tbody = '';
    
    if (survey_selected === 'FESP10' || survey_selected === 'EPHF10') {
      tbody = drawGapsFesp10(capacities, strategies, current_gaps);
    } else {
      tbody = drawGapsCommonFesp(capacities, current_gaps);
    }

    document.getElementById('translate_gaps').getElementsByTagName('tbody')[0].innerHTML = tbody;
  };

  const drawGapsCommonFesp = (capacities, current_gaps) => {
    let current_capacity, tbody = '';

    Object.keys(current_gaps).forEach(capacity => {
      current_capacity = capacities.filter(r => r.id == capacity)[0].abbreviation;
      
      Object.keys(current_gaps[capacity]).forEach(criterion => {
        tbody += `<tr>
            <td>${current_capacity}</td>
            <td></td>
            <td>${criterion}</td>
            <td><textarea name="${capacity}_${criterion}" class="form-control">${current_gaps[capacity][criterion]}</textarea></td>
          </tr>`
      });
    });

    return tbody;
  };

  const drawGapsFesp10 = (capacities, strategies, current_gaps) => {
    let current_capacity, current_strategy, tbody = '';

    Object.keys(current_gaps).forEach(capacity => {
      current_capacity = capacities.filter(r => r.id == capacity)[0].abbreviation;
      
      Object.keys(current_gaps[capacity]).forEach(strategy => {
        current_strategy = strategies.filter(r => r.code == strategy)[0].question;
        
        Object.keys(current_gaps[capacity][strategy]).forEach(criterion => {
          tbody += `<tr>
            <td>${current_capacity}</td>
            <td>${current_strategy}</td>
            <td>${criterion}</td>
            <td><textarea name="${capacity}_${strategy}_${criterion}" class="form-control">${current_gaps[capacity][strategy][criterion]}</textarea></td>
          </tr>`;
        });
      });
    });

    return tbody;
  };
})();